module.exports = __webpack_public_path__ + "static/picture-5fad7a2e729388ef011230f898190995.jpg";